<template>
    <div>
        <b-row>
            <b-col md="12">
                    <b-card>
                        <b-row>
                            <b-col sm="12" md="4" lg="4">
                                <b-form-group :label="$t('faculty_code')">
                                    {{ formData.faculty_code }}
                                </b-form-group>
                            </b-col>
                            <b-col sm="12" md="4" lg="4">
                                <b-form-group :label="$t('department_code')">
                                    {{ formData.department_code }}
                                </b-form-group>
                            </b-col>
                            <b-col sm="12" md="4" lg="4">
                                <b-form-group :label="$t('program_code')">
                                    {{ formData.code }}
                                </b-form-group>
                            </b-col>
                            <b-col sm="12" md="4" lg="4">
                                <b-form-group :label="$t('program_name')">
                                    {{ getLocaleText(formData, 'name') }}
                                </b-form-group>
                            </b-col>
                            <b-col sm="12" md="4" lg="4">
                                <b-form-group :label="$t('program_level')">
                                    {{ getLocaleText(formData, 'level_text') }}
                                </b-form-group>
                            </b-col>
                            <b-col sm="12" md="4" lg="4">
                                <b-form-group :label="$t('program_language')">
                                    {{ formData.language }}
                                </b-form-group>
                            </b-col>
                            <b-col sm="12" md="4" lg="4">
                                <b-form-group :label="$t('program_duration')">
                                    {{ formData.duration }}
                                </b-form-group>
                            </b-col>
                        </b-row>

                    </b-card>
                </b-col>
        </b-row>
        <b-row>
            <b-col md="12" class="mt-2">
                <b-card :header="$t('program_outcome_definition_name').toUpper()+' '+$t('period').toUpper()" header-tag="header">
                    <ValidationObserver ref="formValidate">
                        <b-row>
                            <b-col sm="12" md="6">
                                <ValidationProvider name="semester_id" rules="required" v-slot="{ errors }">
                                    <b-form-group :label="$t('semester')">
                                        <semesters-selectbox
                                            @input="getData"
                                            v-model="newFormData.semester_id"
                                            :validate-error="errors[0]"/>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col sm="12" md="12">
                                <b-row v-show="newFormData.semester_id">
                                    <b-col sm="12" md="12" class="mb-2" v-for="outcome in outcomes" :key="outcome.id">
                                        <b-form-checkbox :id="'checkbox'+outcome.id"
                                                         v-model="outcome.checked"
                                                         @change="update(outcome)"
                                                         :value="outcome.id">
                                            <span>{{ getLocaleText(outcome, 'name') }}</span>
                                        </b-form-checkbox>
                                    </b-col>
                                </b-row>
                            </b-col>
                        </b-row>
                    </ValidationObserver>
                </b-card>
            </b-col>
        </b-row>
        <b-row v-show="1 == 2">
            <b-col md="12" class="mt-2">
                <b-card>
                    <b-row>
                        <b-col md="12" v-if="checkPermission('programoutcomesemester_store')">
                            <b-button variant="primary" @click="newOutcome">{{ $t('new') }}</b-button>
                        </b-col>
                        <b-col md="12">
                            <b-table
                                :empty-filtered-text="$t('no_result')"
                                :empty-text="$t('no_result')"
                                bordered
                                striped
                                responsive
                                :items="tableData"
                                :fields="tableFields"
                                show-empty
                                class="mb-5 mt-2 table-dropdown no-scrollbar border rounded">
                                <template #cell(show_in_diploma_supplement)="row">
                                    {{ row.item.show_in_diploma_supplement == true ? $t('yes') : $t('no') }}
                                </template>
                                <template #cell(buttons)="row">
                                    <b-dropdown variant="link btn-sm" boundary="window" no-caret>
                                        <template #button-content>
                                            <i class="ri-more-fill"></i>
                                        </template>
                                        <div id="dropdownListHead">
                                            <b-dropdown-item @click="openUpdateBox(row.item)" v-if="checkPermission('programoutcomesemester_update')">
                                                <i class="ri-edit-box-line align-middle top-minus-1 mr-3 text-muted"></i> {{$t('edit')}}
                                            </b-dropdown-item>
                                            <b-dropdown-item @click="deleteOutcome(row.item)" v-if="checkPermission('programoutcomesemester_delete')">
                                                <i class="ri-delete-bin-2-line align-middle top-minus-1 mr-3 text-muted"></i> {{$t('delete')}}
                                            </b-dropdown-item>
                                        </div>
                                    </b-dropdown>
                                </template>
                            </b-table>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
// Components
import ProgramOutcomeDefinitionSelectbox from "@/components/interactive-fields/ProgramOutcomeDefinitionSelectbox"
import CommonModal from "@/components/elements/CommonModal"
import SemestersSelectbox from "@/components/interactive-fields/SemestersSelectbox"

// Services
import ProgramOutcome from "@/services/ProgramOutcome"
import ProgramOutcomeDefinition from "@/services/ProgramOutcomeDefinition"


// Other
import { ValidationObserver, ValidationProvider } from "vee-validate";
import qs from "qs";
import {checkPermission} from "@/main";

export default {
    components: {
        ValidationObserver,
        ValidationProvider,
        ProgramOutcomeDefinitionSelectbox,
        CommonModal,
        SemestersSelectbox
    },
    props: {
        program: {
            type: Object,
        },
    },
    data() {
        return {
            formLoading: false,
            formData: {},
            tableData: [],
            tableFields: [
                {
                    key: 'buttons',
                    label: ''
                },
                {
                    key: this.getLocaleField('program_outcome_name'),
                    label: this.$t('program_outcome_definition_name')
                },
                {
                    key: this.getLocaleField('semester_name'),
                    label: this.$t('semester')
                }
            ],
            isNew: false,
            newFormData: {},
            outcomes: null
        };
    },
    created() {
        this.formData = this.program
        this.getOutcomes()
    },
    methods: {
        getOutcomes() {
            const config = {
                params: {
                    sort:'-id',
                    limit:-1
                },
                paramsSerializer: (params) => qs.stringify(params, {encode: false}),
            };
            ProgramOutcomeDefinition.getAll(config).then(response => {
                this.outcomes = response.data.data
            }).catch(e => {
                this.showErrors(e, null)
            })
        },

        getData(selected){
            const config = {
                params: {
                    filter: {
                        program_code: this.program.code,
                        semester_id: selected
                    },
                    sort: 'id',
                    limit: -1
                },
                paramsSerializer: (params) => qs.stringify(params, { encode: false })
            };

            ProgramOutcome.getAllOutcomeSemesters(config).then(response => {
                this.outcomes.forEach((item, index) => {
                    delete this.outcomes[index].checked
                    response.data.data.forEach(item2 => {
                        if(item2.program_outcome_id == item.id){
                            this.outcomes[index].checked = item.id
                            this.outcomes[index].program_outcome_semester_id = item2.id
                        }
                    })
                })
                this.tableData = response.data.data
            }).catch(e => {
                this.showErrors(e)
            })
        },

        update(data){
            if(checkPermission('programoutcomesemester_update') && checkPermission('programoutcomesemester_delete')){
                if(data.id == data.checked){
                    let formData = {
                        semester_id: this.newFormData.semester_id,
                        program_outcome_id: data.id
                    }
                    ProgramOutcome.storeOutcomeSemesters(formData).then(response => {
                        this.$toast.success(this.$t('api.' + response.data.message))
                    }).catch(e => {
                        this.showErrors(e, this.$refs.formValidate)
                    })
                } else {
                    ProgramOutcome.delOutcomeSemesters(data.program_outcome_semester_id).then(response => {
                        this.$toast.success(this.$t('api.' + response.data.message))
                    }).catch(e => {
                        this.showErrors(e)
                    })
                }
            } else {
                this.$toast.error(this.$t('unauthorized_operation'));
            }
        },

        newOutcome() {
            this.newFormData = {}
            return this.isNew = !this.isNew
        },

        async save(){
            const isValid = await this.$refs.formValidate.validate();
            if (isValid) {
                this.formLoading = true
                this.newFormData.program_code = this.program.code
                if(this.newFormData.id) {
                    ProgramOutcome.updateOutcomeSemesters(this.newFormData.id, this.newFormData).then(response => {
                        this.$toast.success(this.$t('api.' + response.data.message));
                        this.formLoading = false
                        this.getData()
                        this.isNew = false
                        this.newFormData = {}
                    }).catch(e => {
                        this.showErrors(e, this.$refs.formValidate);
                        this.formLoading = false
                    })
                } else {
                    ProgramOutcome.storeOutcomeSemesters(this.newFormData).then(response => {
                        this.$toast.success(this.$t('api.' + response.data.message));
                        this.formLoading = false
                        this.getData()
                        this.isNew = false
                        this.newFormData = {}
                    }).catch(e => {
                        this.showErrors(e, this.$refs.formValidate);
                        this.formLoading = false
                    })
                }
            }
        },

        openUpdateBox(data){
            this.isNew = true
            data.show_in_diploma_supplement = data.show_in_diploma_supplement == true ? 1 : 0
            this.newFormData = data
        },

        deleteOutcome(data){
            this.$swal
                .fire({
                    title: this.$t('attention'),
                    text: this.$t('are_you_sure_to_delete'),
                    showCancelButton: true,
                    confirmButtonText: this.$t('yes'),
                    cancelButtonText: this.$t('no'),
                }).then((result) => {
                    if (result.isConfirmed) {
                        ProgramOutcome.delOutcomeSemesters(data.id).then(response => {
                            this.$toast.success(this.$t('api.' + response.data.message));
                            this.getData()
                        }).catch(e => {
                            this.showErrors(e)
                        })
                    }
                })
        }

    },
}
</script>
